import styled from "styled-components"

export const Grid = styled.div`
  display: grid;
  gap: 2.5rem;
  @media (min-width: 992px) {
    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
    gap: 5rem;
    align-items: start;
  }
`

export const Text = styled.div`
  max-width: var(--measure);
  p {
    font-size: 1.125rem;
    line-height: 1.55;
  }
`

export const Facts = styled.ul`
  list-style: none;
  margin: 0 0 2.25rem;
  padding: 0;
  border-top: 1px solid var(--line-strong);
  li {
    margin: 0;
    padding: 0.9rem 0;
    border-bottom: 1px solid var(--line);
  }
`

export const StackTitle = styled.h3`
  margin-bottom: 0.25rem;
  font-family: var(--font-body);
  font-size: 1.0625rem;
  font-weight: 600;
  letter-spacing: 0;
`

export const Stack = styled.dl`
  margin: 0;
  > div {
    display: grid;
    grid-template-columns: 9.5rem minmax(0, 1fr);
    gap: 0.5rem;
    padding: 0.6rem 0;
    border-top: 1px solid var(--line);
  }
  dt {
    font-weight: 600;
  }
  dd {
    margin: 0;
    color: var(--muted);
  }
`
